"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineNumberFormatterService = void 0;
const v1_1 = require("./v1");
function defineNumberFormatterService(config) {
    return {
        id: "audi-number-formatter-service",
        optionalDependencies: {
            featureServices: {
                "s2:logger": "^1.0.0",
            },
        },
        create: ({ featureServices }) => {
            const { "s2:logger": logger } = featureServices;
            if (config === undefined || config === null) {
                throw new Error("NumberFormatterService requires a configuration.");
            }
            return {
                "1.0.0": () => {
                    return {
                        featureService: new v1_1.NumberFormatterServiceV1(config, logger),
                    };
                },
            };
        },
    };
}
exports.defineNumberFormatterService = defineNumberFormatterService;
//# sourceMappingURL=index.js.map